/**
 * @file
 * A JavaScript file containing the sitewide notification modal init function.
 *
 */

/**
 * Enter Espoo JS.
 */
(function($) {

  // Triggered when cookies accepted or declined.
  window.addEventListener("cookieConsentHidden", (event) => {
    initNotification();
  });

  // Triggered when rendered and if cookie consent not showing.
  $(document).on("sitewide-alert-rendered", '.alert-modal' ,function() {
    if ($('body').hasClass('hide-cookie-consent'))
    initNotification();
  });

  function initNotification() {
    // Get alert and add class to show it after the set delay.
    var alerts = document.getElementsByClassName("alert-modal");

    if (alerts.length > 0) {

      // Get delay.
      var timeOut = alerts[0].getAttribute("data-delay");
      if (timeOut === "undefined") {
        timeOut = 0;
      }

      // Change to milliseconds
      timeOut = timeOut * 1000;

      setTimeout(() => {
        alerts[0].classList.add("initialized");
      }, timeOut);
    }
  }

})(jQuery);
